import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProjectWindowComponent } from '../../../project/view/project-window/project-window.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ProjectInfoComponent } from 'projects/mobile/src/app/modules/project/view/project-info/project-info.component';
import { MatDialog } from '@angular/material/dialog';
import { DocusignDialogComponent } from 'projects/app-misc/src/app/modules/docusign/view/docusign-dialog/docusign-dialog.component';

@Component({
    selector: 'app-home-board',
    templateUrl: './home-board.component.html',
    styleUrls: ['./home-board.component.scss']
})
export class HomeBoardComponent implements OnInit {

    isMobile = false;
    isTablet = false;

    constructor(
        protected dialog: MatDialog,
        private route: ActivatedRoute,
        protected deviceDetectorService: DeviceDetectorService
    ) {
        this.isMobile = this.deviceDetectorService.isMobile();
        this.isTablet = this.deviceDetectorService.isTablet();

        this.route.params.subscribe(params => {
            const projId = params.id;
            if (projId) {
                this.openProject(projId)
            }
        }); { }


        // this.openProject('5982')
    }

    ngOnInit(): void {
        // this.openDocu();
    }


    openProject(projectId: string) {
        let projectWindow = ProjectWindowComponent as any;

        let panelClass = 'project-window-dialog'

        if (this.isMobile || this.isTablet) {
            projectWindow = ProjectInfoComponent
            panelClass = 'project-info-dialog'
        }

        const dialogRef = this.dialog.open(projectWindow, {
            data: {
                projectCode: projectId
            },
            panelClass
        });

        dialogRef.afterClosed().subscribe(result => {
        });
    }
}
